import {
  ArrowForward as ArrowForwardIcon,
  ArrowUpward as ArrowUpwardIcon,
} from '@mui/icons-material';
import { Box } from '@mui/material';
import ToggleButtonGroup from '@mui/material/ToggleButtonGroup';
import { isString } from 'lodash';
import React from 'react';
import { DISCLAIMER_POSITION } from 'src/features/components/editComponentPage/forms/FormSelector.interface';

import { WidgetsCommonProps } from '../widget.interface';
import { InputLabel, ToggledButtons } from './DisclaimerPositionWidget.styled';

export const DisclaimerPositionButtonsWidget = React.forwardRef(
  (props: WidgetsCommonProps, ref) => {
    const handlePosition = (
      event: React.MouseEvent<HTMLElement>,
      position: string | null,
    ) => {
      if (position) props.onChange(position);
    };

    return (
      <>
        <InputLabel>{props.label}</InputLabel>
        <Box ref={ref}>
          <ToggleButtonGroup
            value={props.value}
            exclusive
            onChange={handlePosition}
            aria-label={isString(props.label) ? props.label : ''}>
            <ToggledButtons
              value={DISCLAIMER_POSITION.BOTTOM_HORIZONTAL}
              aria-label="left aligned">
              <ArrowForwardIcon />
            </ToggledButtons>
            <ToggledButtons
              value={DISCLAIMER_POSITION.RIGHT_VERTICAL}
              aria-label="right aligned">
              <ArrowUpwardIcon />
            </ToggledButtons>
          </ToggleButtonGroup>
        </Box>
      </>
    );
  },
);
